// extracted by mini-css-extract-plugin
export var headerCell = "_6d-1";
export var loadingSpinnerContainer = "_6d-4";
export var loadingStateCell = "_6d-5";
export var rowWrapper = "_6d-3";
export var standaloneTable = "_6d-6";
export var table = "_6d-0";
export var white = "_6d-2";